import React from 'react';
import { mergeIntervals } from '../../utils';
import { HighlightedSearch } from './styled';
export var Highlighter = function (_a) {
    var label = _a.optionLabel, searchValue = _a.searchValue;
    var optionLabel = label.toString();
    if (searchValue.length) {
        var matchIndexes = searchValue
            .filter(function (word) { return word.length; })
            .reduce(function (acc, word) {
            var startIndex = -1;
            while ((startIndex = optionLabel
                .toLowerCase()
                .indexOf(word.toLowerCase(), startIndex + 1)) !== -1) {
                var endIndex = startIndex + word.length;
                acc.push([startIndex, endIndex]);
            }
            return acc;
        }, []);
        if (matchIndexes.length) {
            var mergedMatchIndexes_1 = mergeIntervals(matchIndexes);
            var prefix = {
                word: optionLabel.substring(0, mergedMatchIndexes_1[0][0]),
                highlighted: false,
            };
            var postfix_1 = {
                word: optionLabel.substring(mergedMatchIndexes_1[mergedMatchIndexes_1.length - 1][1]),
                highlighted: false,
            };
            var chunks = mergedMatchIndexes_1.reduce(function (acc, interval, index) {
                acc.push({
                    word: optionLabel.substring(interval[0], interval[1]),
                    highlighted: true,
                });
                var nextInterval = mergedMatchIndexes_1[index + 1];
                if (nextInterval) {
                    acc.push({
                        word: optionLabel.substring(interval[1], nextInterval[0]),
                        highlighted: false,
                    });
                }
                else {
                    acc.push(postfix_1);
                }
                return acc;
            }, [prefix]);
            return (React.createElement(React.Fragment, null, chunks.map(function (chunk) {
                if (chunk.highlighted) {
                    return React.createElement(HighlightedSearch, null, chunk.word);
                }
                return chunk.word;
            })));
        }
    }
    return React.createElement(React.Fragment, null, optionLabel);
};
//# sourceMappingURL=Highlighter.js.map